// src/msalInstance.ts
import { PublicClientApplication } from "@azure/msal-browser";
import type { AuthenticationResult, PopupRequest } from "@azure/msal-browser";
import { msalConfig } from "./msalConfig";

export const msalInstance = new PublicClientApplication(msalConfig);

// MSAL v5 requires initialize() and any pending redirect response to be
// processed BEFORE the app reads accounts or renders. This is awaited once in
// index.tsx bootstrap() so the app boots with the signed-in session known.

// MSAL allows one popup per tab; a second call throws interaction_in_progress.
// Concurrent callers asking for the same scopes share the popup already open.
const openPopups = new Map<string, Promise<AuthenticationResult>>();

export function acquireTokenPopupOnce(request: PopupRequest): Promise<AuthenticationResult> {
  const key = [...request.scopes].sort().join(" ");
  const open = openPopups.get(key);
  if (open) return open;
  const popup = msalInstance.acquireTokenPopup(request);
  openPopups.set(key, popup);
  popup.finally(() => openPopups.delete(key)).catch(() => {});
  return popup;
}
